module.exports = {
  NODE_ENV: '"production"'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 687
// module chunks = 1